import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import { IconTile } from "../../components/ui";
import { CheckList, DirArrow, FeatureCard, PageHero, Section, stripBullet } from "./MarketingParts";

export default function MarketingPartners() {
  const { t } = useTranslation();
  const steps = [t("m_partners_start_1"), t("m_partners_start_2"), t("m_partners_start_3")];

  return (
    <>
      <PageHero
        eyebrow={t("mk_partners_eyebrow")}
        icon={<HandshakeOutlinedIcon sx={{ fontSize: 16 }} aria-hidden="true" />}
        title={t("m_partners_title")}
        subtitle={t("m_partners_subtitle")}
        actions={
          <>
            <Button variant="contained" size="large" component={RouterLink} to="/contact" endIcon={<DirArrow />}>
              {t("m_partners_cta_talk")}
            </Button>
            <Button variant="outlined" size="large" component={RouterLink} to="/pricing">
              {t("m_partners_cta_pricing")}
            </Button>
          </>
        }
      />

      <Section sx={{ pt: { xs: 5, md: 7 } }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 2.5, md: 3 } }}>
          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44}>
                <CardGiftcardOutlinedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_partners_benefits_title")}
              </Typography>
            </Stack>
            <CheckList items={[t("m_partners_benefits_1"), t("m_partners_benefits_2"), t("m_partners_benefits_3")]} />
          </FeatureCard>

          <FeatureCard>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }}>
              <IconTile size={44} tone="teal">
                <RocketLaunchOutlinedIcon />
              </IconTile>
              <Typography variant="h2" sx={{ fontSize: "1.25rem" }}>
                {t("m_partners_start_title")}
              </Typography>
            </Stack>
            <Box component="ol" sx={{ listStyle: "none", m: 0, p: 0, display: "grid", gap: 1.25 }}>
              {steps.map((s, i) => (
                <Box component="li" key={i} sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                  <Box
                    aria-hidden="true"
                    sx={{ width: 26, height: 26, flex: "none", borderRadius: "50%", bgcolor: "primary.main", color: "#fff", display: "grid", placeItems: "center", fontWeight: 700, fontSize: "0.8rem" }}
                  >
                    {i + 1}
                  </Box>
                  <Typography sx={{ color: "text.secondary", lineHeight: 1.6, pt: "2px" }}>{stripBullet(s)}</Typography>
                </Box>
              ))}
            </Box>
          </FeatureCard>
        </Box>
      </Section>
    </>
  );
}
